import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "van-notify--warning text-sm"
}
const _hoisted_2 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-4 bg-gray-lightShow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "show_logo",
    class: "m-auto object-cover"
  })
], -1)
const _hoisted_4 = { class: "pb-8" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "absolute z-20 bottom-0 left-0 w-full px-6 py-6" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = { class: "text-left text-white text-2xl font-medium pb-2" }
const _hoisted_9 = { class: "text-left text-white font-light pb-2" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "space-y-8" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "pb-20 space-y-8" }
const _hoisted_17 = { class: "py-4 space-y-2" }
const _hoisted_18 = { class: "flex justify-between px-4" }
const _hoisted_19 = { class: "text-left" }
const _hoisted_20 = { class: "text-base font-medium" }
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "table-cell align-bottom text-sm font-medium" }, " View all ", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "text-left mt-1" }
const _hoisted_28 = { class: "text-sm font-medium h-10 line-clamp-2" }
const _hoisted_29 = {
  key: 0,
  class: "text-base font-medium"
}
const _hoisted_30 = { class: "space-x-2 text-sm font-medium" }
const _hoisted_31 = {
  key: 0,
  class: "text-gray-400 line-through"
}
const _hoisted_32 = {
  key: 1,
  class: "text-green-lightShow font-medium"
}
const _hoisted_33 = { class: "text-sm font-medium text-green-lightShow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_SProfileSnsAuthDialog = _resolveComponent("SProfileSnsAuthDialog")!
  const _component_SBottomBar = _resolveComponent("SBottomBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.env !== 'production')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " テスト中(" + _toDisplayString(_ctx.env) + ") ", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, _toDisplayString(_ctx.migrationCode || '取得に失敗'), 1),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_swipe, {
          "show-indicators": true,
          "indicator-color": "#374C4E"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (banner) => {
              return (_openBlock(), _createBlock(_component_van_swipe_item, {
                key: banner.bannerId
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "w-full",
                    onClick: ($event: any) => (_ctx.goLinkedBanner(banner.transitionPageUrl))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("p", _hoisted_8, _toDisplayString(banner.title), 1),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(banner.description), 1)
                      ])
                    ]),
                    _createElementVNode("img", {
                      src: banner.imageUrl,
                      alt: "",
                      class: "h-[514px] object-cover"
                    }, null, 8, _hoisted_10)
                  ], 8, _hoisted_5)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createVNode(_component_van_swipe, {
              width: 85,
              loop: false,
              "show-indicators": false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.voucherCategories, (category) => {
                  return (_openBlock(), _createBlock(_component_van_swipe_item, {
                    key: category.voucherCategoryId
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "text-center m-2",
                        onClick: ($event: any) => (_ctx.goBrowseCategory(category.voucherCategoryId))
                      }, [
                        _createElementVNode("img", {
                          src: category.imageUrl,
                          alt: category.name,
                          height: 70,
                          width: 70,
                          class: "rounded-full aspect-square m-auto object-cover"
                        }, null, 8, _hoisted_14),
                        _createElementVNode("p", {
                          class: "text-xs font-medium mt-2 break-keep",
                          innerHTML: _ctx.getSmallCategoryTitle(category.name)
                        }, null, 8, _hoisted_15)
                      ], 8, _hoisted_13)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryVouchers, (categoryVoucher) => {
            return (_openBlock(), _createElementBlock("div", {
              key: categoryVoucher.category.voucherCategoryId
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("p", _hoisted_20, _toDisplayString(categoryVoucher.category.name), 1),
                    _createElementVNode("p", _hoisted_21, _toDisplayString(categoryVoucher.category.nameEn), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "table",
                    onClick: ($event: any) => (
                  _ctx.goBrowseCategory(categoryVoucher.category.voucherCategoryId)
                )
                  }, _hoisted_24, 8, _hoisted_22)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_van_swipe, {
                    loop: false,
                    "show-indicators": false,
                    width: _ctx.categoryVoucherWidth,
                    class: "px-2"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryVoucher.vouchers, (voucher) => {
                        return (_openBlock(), _createBlock(_component_van_swipe_item, {
                          key: voucher.voucherId
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "pr-2",
                              onClick: ($event: any) => (_ctx.goVoucherDetail(voucher.voucherId))
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("img", {
                                  src: 
                          voucher.images.sort((a, b) =>
                            (a.id as number) > (b.id as number) ? 1 : -1,
                          )[0].imageUrl ||
                          require('@/assets/images/no_image.png')
                        ,
                                  alt: "",
                                  class: "aspect-square w-full object-cover"
                                }, null, 8, _hoisted_26)
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("p", _hoisted_28, _toDisplayString(voucher.name), 1),
                                _createElementVNode("div", null, [
                                  (
                            !!voucher.discountedPrice ||
                            voucher.discountedPrice === 0
                          )
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, " ￥" + _toDisplayString(voucher.discountedPrice.toLocaleString()), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("p", _hoisted_30, [
                                    (voucher.price != 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, " ￥" + _toDisplayString(voucher.price.toLocaleString()), 1))
                                      : _createCommentVNode("", true),
                                    (
                              voucher.discountType === _ctx.DiscountTypes.Amount ||
                              voucher.discountType === _ctx.DiscountTypes.Rate
                            )
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(voucher.discountValue.toLocaleString()) + " " + _toDisplayString(_ctx.SuffixDiscountValueLabels[voucher.discountType]), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_33, _toDisplayString(voucher.summary), 1)
                              ])
                            ], 8, _hoisted_25)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["width"])
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_SProfileSnsAuthDialog),
      _createVNode(_component_SBottomBar)
    ])
  ], 64))
}